// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PassengerManifest.css */
.passenger-manifest {
    padding: 2rem;
    background: #e8fff3;
    max-width: 600px;
    margin: auto;
    border-radius: 8px;
    text-align: center;
}

button {
    padding: 10px 20px;
    background-color: #004aad;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

    button:hover {
        background-color: #003b91;
    }
`, "",{"version":3,"sources":["webpack://./src/pages/demo/CrewPassenger/PassengerManifest.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;IAEI;QACI,yBAAyB;IAC7B","sourcesContent":["/* PassengerManifest.css */\n.passenger-manifest {\n    padding: 2rem;\n    background: #e8fff3;\n    max-width: 600px;\n    margin: auto;\n    border-radius: 8px;\n    text-align: center;\n}\n\nbutton {\n    padding: 10px 20px;\n    background-color: #004aad;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n    button:hover {\n        background-color: #003b91;\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
